import React from 'react';
import CSVReader from 'react-csv-reader'
import {InputType} from '../../components/input/input.component';
import {DropDown} from '../../components/dropdown/dropdown.component';



class ProgressBar extends React.Component {
    constructor(){
          super();
          this.state = {
            data: 40, 
            dataType: null,
            isManualError: false,
          }
       }
    isObjectEmpty(obj) {
        for(var key in obj) {
            if(obj.hasOwnProperty(key))
                return true;
        }
        return false;
    }

    handleProgressBarValue = (event)=> {
        let currData = event.target.value;
        this.setState({data: currData});
      }
    progressBar = function(iteration)
      {
          let total, z, percent, filledLength, bar;
          let prefix='Progress:', suffix='Complete',fill = '▓',length=25,  printEnd = "\r";
          total = 25;
          z = 100 * (iteration / parseFloat(total))
          percent = `${z}%`
          filledLength = parseInt(length * iteration/total)
          bar = fill.repeat(filledLength) + '░'.repeat(length - filledLength)
          return (`\r${prefix} |${bar}| ${percent} ${suffix} ${printEnd}\n`);
          
      
      }
    createGraph = ()=>{
        let graph = this.progressBar(this.state.data/4);
        this.setState({graph: graph});
      }
    componentDidMount(){
      this.createGraph();
    }
    render() {
        let dataEntryType = null, graph=null;
        dataEntryType = <div className="col-4"> <InputType type="text" id="inputValues" placeholder="40" label="Values" name="values" handleInputChange={this.handleProgressBarValue} /></div>
  
        if(this.isObjectEmpty(this.state.data)){
            graph = this.state.data <= 100 ? <div>
            {this.progressBar(this.state.data/4)}
          </div> : <p className="error">Percentage should be less or equals to 100</p>
        }
        return (
          <div className="container graph">
            <div className="row">
            <h3 className="col-2">Progress Bar</h3>
            {dataEntryType}
            <div className="col-2"><button className="btn btn-primary " onClick={this.createGraph}>Get chart</button></div>
            {this.state.graph ? <pre className="col-3">{this.state.graph}</pre>:<p className="col-3">No data exists</p> } 

        </div>
        </div>);

        }
}


export default ProgressBar;